import { Injectable } from '@angular/core';
import { ApiBase } from './ApiBase';
import { Observable } from 'rxjs';
import { EnumType, Schema, SchemaUpdateLog, SelectType, StructType } from '@apis/cas/generated';

export type SchemaUpdate = {
  type: string;
  data: Readonly<StructType> | Readonly<EnumType> | Readonly<SelectType>;
};

@Injectable({ providedIn: 'root' })
export class SchemaEndpoints extends ApiBase {
  public getSchema(): Observable<Schema> {
    return this.get<Schema>(`/game/${this.gameId}/schema`);
  }

  updateSchema(selectTypes: SelectType[], structTypes: StructType[], enumTypes: EnumType[]): Observable<SchemaUpdateLog[]> {
    return this.put<SchemaUpdateLog[]>(`/game/${this.gameId}/schema`, {
      selectTypes: selectTypes,
      structTypes: structTypes,
      enumTypes: enumTypes,
    });
  }
}

export * from './schema/EnumTypeEndpoints';
export * from './schema/SelectTypeEndpoints';
export * from './schema/StructTypeEndpoints';
